/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "card_management": {
            "nested": {
              "CreateUserAuthorizationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "authenticationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CreateUserAuthorizationResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.bizbank.card_management.CreateUserAuthorizationResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SUCCESS": 1,
                      "ERROR": 2,
                      "INVALID_TOKEN": 3,
                      "EXPIRED_TOKEN": 4
                    }
                  }
                }
              },
              "GetPrivateCardDataRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "loggableSessionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PrivateCardData": {
                "fields": {
                  "fullPan": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cvc": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expiration": {
                    "type": ".squareup.common.time.YearMonth",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetPrivateCardDataResponse": {
                "fields": {
                  "privateCardInfo": {
                    "type": ".squareup.bizbank.card_management.PrivateCardData",
                    "id": 1
                  },
                  "error": {
                    "type": ".squareup.bizbank.card_management.GetPrivateCardDataResponse.Error",
                    "id": 2
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "ERROR": 1,
                      "UNAUTHORIZED": 2
                    }
                  },
                  "result": {
                    "oneof": ["privateCardInfo", "error"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.CreateUserAuthorizationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.CreateUserAuthorizationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.CreateUserAuthorizationResponse?.nested?.Result && !$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.GetPrivateCardDataRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.PrivateCardData && !$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.GetPrivateCardDataResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.GetPrivateCardDataResponse?.nested?.Error) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateUserAuthorizationRequest @ squareup/bizbank/card_management.proto at 13:1
 */
export const CreateUserAuthorizationRequest = $root.lookupType('squareup.bizbank.card_management.CreateUserAuthorizationRequest');
fixType(CreateUserAuthorizationRequest, {
  authenticationToken: {
    required: true
  }
});
Builder.createAndAttachToType(CreateUserAuthorizationRequest);
/**
 * SOURCE CreateUserAuthorizationResponse @ squareup/bizbank/card_management.proto at 22:1
 */
export const CreateUserAuthorizationResponse = $root.lookupType('squareup.bizbank.card_management.CreateUserAuthorizationResponse');
fixType(CreateUserAuthorizationResponse, {
  result: {
    required: true
  }
});
Builder.createAndAttachToType(CreateUserAuthorizationResponse);
/**
 * Invalid token will be returned if two factor authentication code is invalid or expired
 *
 * SOURCE Result @ squareup/bizbank/card_management.proto at 24:3
 */
CreateUserAuthorizationResponse.Result = $root.lookupEnum('squareup.bizbank.card_management.CreateUserAuthorizationResponse.Result').values;
/**
 * SOURCE GetPrivateCardDataRequest @ squareup/bizbank/card_management.proto at 35:1
 */
export const GetPrivateCardDataRequest = $root.lookupType('squareup.bizbank.card_management.GetPrivateCardDataRequest');
fixType(GetPrivateCardDataRequest, {
  cardToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetPrivateCardDataRequest);
/**
 * Private card info that cannot be stored in Bizbank or clients
 *
 * SOURCE PrivateCardData @ squareup/bizbank/card_management.proto at 49:1
 */
export const PrivateCardData = $root.lookupType('squareup.bizbank.card_management.PrivateCardData');
fixType(PrivateCardData);
Builder.createAndAttachToType(PrivateCardData);
/**
 * SOURCE GetPrivateCardDataResponse @ squareup/bizbank/card_management.proto at 58:1
 */
export const GetPrivateCardDataResponse = $root.lookupType('squareup.bizbank.card_management.GetPrivateCardDataResponse');
fixType(GetPrivateCardDataResponse);
Builder.createAndAttachToType(GetPrivateCardDataResponse);
/**
 * SOURCE Error @ squareup/bizbank/card_management.proto at 59:3
 */
GetPrivateCardDataResponse.Error = $root.lookupEnum('squareup.bizbank.card_management.GetPrivateCardDataResponse.Error').values;